import {FC} from 'react';

import Button from '@/shared/components/button';
import {localize} from '@/shared/services/i18n';

import RegisterCard from '../RegisterCard';
import {LOGIN_CARD} from './consts';

interface AdvantageSectionProps {
  handleSignInWithEmail: () => void;
}

const AdvantageSection: FC<AdvantageSectionProps> = ({
  handleSignInWithEmail,
}) => {
  return (
    <section className="py- flex flex-col items-center gap-4 bg-white px-4 py-14 sm:px-12 sm:py-20">
      <div className="flex flex-col gap-4 sm:flex-row">
        {LOGIN_CARD.map((card) => (
          <RegisterCard
            key={card.titleKey}
            image={card.image}
            title={localize(card.titleKey)}
            description={localize(card.descriptionKey)}
          />
        ))}
      </div>
      <Button
        onClick={handleSignInWithEmail}
        variant="primary"
        size="standard"
        className="w-full max-w-96"
      >
        {localize('landing_try_now_label')}
      </Button>
    </section>
  );
};

export default AdvantageSection;
